import { Box, HStack, Image, Text, Stack, Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from '@chakra-ui/react';
import React, { useState, useEffect, useRef } from 'react';
// import { GiHamburgerMenu } from 'react-icons/gi';
// import { GrClose } from 'react-icons/gr';
import Harmburger from './Common/Hamburger';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
  const [navbar, setNavbar] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  
  // const openMobileMenu = () => {
  //   setIsOpened(!isOpened);
  // };

  const AddBgOnScroll = () => {
    const scrollHeight = 100;
    const pos = window.scrollY;

    if (pos >= scrollHeight) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', AddBgOnScroll);
  }, []);

  const dropDown = useRef(null);



  return (
    <Box
      bgColor={navbar ? 'white' : 'white'}
      p={['1rem', '.5rem']}
      w="full"
      fontFamily="Work Sans"
      ref={dropDown}
      boxShadow={navbar ? '0px 2px 8px rgba(74, 74, 104, 0.15)' : '0px 2px 8px rgba(74, 74, 104, 0.15)'}
      transition={navbar ? '0.5s ease' : ''}
      pos="sticky"
      justify="space-between"
      align="center"
      top="0"
      color={navbar ? '#000' : '#000'}
      zIndex={5}
    >
      <Box display={['block', 'none']}>
        <HStack w="full" alignItems="center" justifyContent="space-between">
          <Box mb=".5rem">
            <NavLink to="/">
              <Image alt="logo" boxSize="75%" src="/new_neemble.svg" />
            </NavLink>
          </Box>
          <Box
                display={["block", "none"]}
                zIndex={10}
                alignItems="flex-end"
                onClick={() => setIsOpened((prev) => !prev)}
            >
                <Harmburger isOpened={isOpened} />
            </Box>
        </HStack>
      </Box>
      <Stack
        direction={['column', 'row']}
        pos={['fixed', 'unset']}
        bgColor={['white', 'unset']}
        width={['85%', 'full']}
        left={isOpened ? '0' : '-100%'}
        top="0"
        fontFamily='Duplicate Sans'
        height={['100vh', 'auto']}
        alignItems={['center', 'center']}
        zIndex="3"
        transition={['all .5s ease', 'unset']}
        justifyContent={['center', 'space-between']}
        pl={['1rem', '0']}
        px={['none', '1rem']}
      >
        <NavLink to="/">
          <Image
            alt="logo"
            display={['', '']}
            src="/new_neemble.svg"
            py={['1rem', 'none']}
          />
        </NavLink>
        <Stack
          m="auto"
          display="flex"
          alignItems={['center', 'center']}
          direction={['column', 'row']}
          gap={['2', '10']}
        >
          <Accordion allowToggle  position='relative'>
            <AccordionItem borderTop="none" borderBottom="none" w="full">
              <h2>
                <AccordionButton>
                  <Box
                    display="flex"
                    alignItems="center"
                    w="full"
                    textAlign="left"
                  >
                    <Text
                    _hover={{ textDecoration: 'none' }}
                    color="#1F1F29"
                    fontWeight="500"
                    fontFamily='Duplicate Sans'
                    fontSize={['1rem', '1rem', '.7rem', '1rem']}
                    textAlign={['center', 'none']}
                    _active={{ color: '#000' }}
                  >
                    Product
                  </Text> <AccordionIcon />
                  </Box>
                </AccordionButton>
              </h2>
              <AccordionPanel position='absolute' zIndex='10' bg={['#fff','#fff']} w='full' overflowY='auto' pb={4}>
                <NavLink to="/biometric-payment">
                  <Text
                    _hover={{ textDecoration: 'none' }}
                    color="#1F1F29"
                    fontWeight="500"
                    fontFamily='Duplicate Sans'
                    fontSize={['1rem', '1rem', '.7rem', '1rem']}
                    textAlign={['center', 'none']}
                    _active={{ color: '#000' }}
                  >
                    Biometric
                  </Text>
                </NavLink>
                <NavLink to="/qr">
                  <Text
                    _hover={{ textDecoration: 'none' }}
                    color="#1F1F29"
                    fontWeight="500"
                    fontFamily='Duplicate Sans'
                    fontSize={['1rem', '1rem', '.7rem', '1rem']}
                    textAlign={['center', 'none']}
                    _active={{ color: '#000' }}
                  >
                    QR Code
                  </Text>
                </NavLink>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
          <NavLink to="">
            <Text
              _hover={{ textDecoration: 'none' }}
              textAlign={['center', 'none']}
              fontSize={['1rem', '1rem', '.7rem', '1rem']}
              color="#1F1F29"
              fontWeight="500"
              fontFamily='Duplicate Sans'
              _active={{ color: '#000' }}
            >
              Use cases
            </Text>
          </NavLink>
          <Accordion allowToggle  position='relative'>
            <AccordionItem borderTop="none" borderBottom="none" w="full">
              <h2>
                <AccordionButton>
                  <Box
                    display="flex"
                    alignItems="center"
                    w="full"
                    textAlign="left"
                  >
                    <Text
                    _hover={{ textDecoration: 'none' }}
                    color="#1F1F29"
                    fontWeight="500"
                    fontFamily='Duplicate Sans'
                    fontSize={['1rem', '1rem', '.7rem', '1rem']}
                    textAlign={['center', 'none']}
                    _active={{ color: '#000' }}
                  >
                    Company
                  </Text> <AccordionIcon />
                  </Box>
                </AccordionButton>
              </h2>
              <AccordionPanel bg={['#fff','#fff']}   position='absolute' zIndex='10' w='full' overflowY='auto' pb={4}>
                <NavLink to="/about">
                  <Text
                    _hover={{ textDecoration: 'none' }}
                    color="#1F1F29"
                    fontWeight="500"
                    fontFamily='Duplicate Sans'
                    fontSize={['1rem', '1rem', '.7rem', '1rem']}
                    textAlign={['center', 'none']}
                    _active={{ color: '#000' }}
                  >
                    About
                  </Text>
                </NavLink>
                <NavLink to="/contact">
                  <Text
                    _hover={{ textDecoration: 'none' }}
                    fontFamily='Duplicate Sans'
                    color="#1F1F29"
                    fontWeight="500"
                    fontSize={['1rem', '1rem', '.7rem', '1rem']}
                    textAlign={['center', 'none']}
                    _active={{ color: '#000' }}
                  >
                    Contact us
                  </Text>
                </NavLink>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
          <NavLink to="">
            <Text
              _hover={{ textDecoration: 'none' }}
              textAlign={['center', 'none']}
              fontSize={['1rem', '1rem', '.7rem', '1rem']}
              color="#1F1F29"
              fontFamily='Duplicate Sans'
              fontWeight="500"
              _active={{ color: '#000' }}
            >
              Pricing
            </Text>
          </NavLink>
        </Stack>
        <Stack
          m="auto"
          display="flex"
          alignItems={['center', 'center']}
          direction={['column', 'row']}
          gap={['2', '10']}
        >
          <NavLink to="">
            <Text
              _hover={{ textDecoration: 'none' }}
              textAlign={['center', 'none']}
              fontSize={['1rem', '1rem', '.7rem', '1rem']}
              color="#1F1F29"
              fontWeight="500"
              fontFamily='Duplicate Sans'
              _active={{ color: '#000' }}
            >
              Login
            </Text>
          </NavLink>
          <Text
            _hover={{ textDecoration: 'none' }}
            textAlign="center"
            fontSize={['1rem', '1rem', '.7rem', '1rem']}
            color="#fff"
            bg="#246BFD"
            p=".4rem 1.2rem"
            borderRadius="16px"
            fontFamily='Duplicate Sans'
            fontWeight="500"
            _active={{ color: '#000' }}
          >
            Get Started
          </Text>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Navbar;
